<template>
  <div class="flex flex-col lg:h-screen lg:overflow-hidden admin-layout">
    <SystemAnnouncementStack />
    <div class="lg:flex flex-1 lg:overflow-hidden">
      <SideBar />
      <div class="flex w-full flex-col overflow-y-auto bg-gray-50">
        <div class="min-h-screen p-4">
          <div class="flex w-full items-center bg-white p-4">
            <AppBreadcrumb v-if="breadcrumbItems" :items="breadcrumbItems" :home-route="{ name: 'admin-home' }" />
            <div class="hidden lg:block pr-4 ml-auto">
              <UserAvatar show-name />
            </div>
          </div>
          <router-view></router-view>
        </div>
      </div>
    </div>
  </div>
  <PermissionDeniedDialog v-model:visible="permissionDeniedStore.visible" :title="permissionDeniedStore.title" :message="permissionDeniedStore.message" />
  <SubmissionErrorDialog v-model:visible="submissionErrorStore.visible" :title="submissionErrorStore.title" :message="submissionErrorStore.message" :errors="submissionErrorStore.errors" />
</template>
<script setup>
import { ref, provide } from 'vue'
import SideBar from '@/layouts/components/admin/SideBar.vue'
import UserAvatar from '@/components/common/UserAvatar.vue'
import AppBreadcrumb from '@/components/common/AppBreadcrumb.vue'
import PermissionDeniedDialog from '@/components/common/PermissionDeniedDialog.vue'
import SubmissionErrorDialog from '@/components/common/SubmissionErrorDialog.vue'
import SystemAnnouncementStack from '@/components/system-announcements/SystemAnnouncementStack.vue'
import { usePermissionDeniedStore } from '@/stores/permissionDenied'
import { useSubmissionErrorStore } from '@/stores/submissionError'

const permissionDeniedStore = usePermissionDeniedStore()
const submissionErrorStore = useSubmissionErrorStore()

const breadcrumbItems = ref(null)
provide('adminBreadcrumb', breadcrumbItems)
</script>
